import { render, staticRenderFns } from "./CCard.vue?vue&type=template&id=7c636f02&scoped=true&"
import script from "./CCard.vue?vue&type=script&lang=js&"
export * from "./CCard.vue?vue&type=script&lang=js&"
import style0 from "./CCard.vue?vue&type=style&index=0&id=7c636f02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c636f02",
  null
  
)

export default component.exports